import { render, staticRenderFns } from "./IviewTable.vue?vue&type=template&id=ce9658ac&scoped=true&"
import script from "./IviewTable.vue?vue&type=script&lang=js&"
export * from "./IviewTable.vue?vue&type=script&lang=js&"
import style0 from "./IviewTable.vue?vue&type=style&index=0&id=ce9658ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9658ac",
  null
  
)

export default component.exports